/**
 * Ryan O'Dowd
 * 2022-03-21
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors, safeAreaInsets}) => {
  return {
    innerContainer: {
      flex: 1,
    },
    list: {
      paddingBottom: safeAreaInsets.bottom,
    },
    fab: {
      position: 'absolute',
      right: 16,
      bottom: 16,
      backgroundColor: colors.accent,
    },
    fakeFab: { // @TODO: rename
      display: 'flex',
      width: 56,
      height: 56,
      margin: 16,
      marginTop: 0,
      alignSelf: 'flex-end',
    },
    tooltipWrapper: { // @TODO: rename
      alignItems: 'flex-end',
    },

    // @TODO: duplicated in Goals/styles.native.js; yeet after removing walkthrough as dep {
    walkthroughContentRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginTop: 8,
      marginBottom: 8,
      marginRight: 8,
    },
    walkthroughText: {
      display: 'flex',
      flexShrink: 1,
      width: '100%',
      height: '100%',
      padding: 4,
      alignSelf: 'flex-start',
      color: colors.primaryExtraDark,
    },
    // @TODO: duplicated in Goals/styles.native.js }
  };
};

export default getStyles;
